import React, {useEffect, useState} from "react";
import {useStore} from "../../hooks/useStore";
import moment from "moment";

export const useShiftRequestManagement = () => {
    const stores = useStore();
    const [shiftRequests, setShiftRequests] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState();
    const [selectedSubCompany, setSelectedSubCompany] = useState();
    const [selectedStatus, setSelectedStatus] = useState("all");
    const [selectedCity, setSelectedCity] = useState("all");
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [selectedShiftRequest, setSelectedShiftRequest] = useState(null);

    const [selectedStartDate, setSelectedStartDate] = useState(
        moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY-MM-DD")
    );

    const [selectedEndDate, setSelectedEndDate] = useState(
        moment()
            .add(1, "months")
            .endOf("month")
            .format("YYYY-MM-DD")
    );

    const [isListLoading, setIsListLoading] = useState(false);

    const getShiftRequests = async () => {
        setIsListLoading(true);

        const shiftRequestsData = await fetchShiftRequests({
            companyId: selectedCompany,
            subcompany: selectedSubCompany,
            startDate: selectedStartDate,
            endDate: selectedEndDate,
            city: selectedCity,
            status: selectedStatus
        });

        if (shiftRequestsData) {
            setShiftRequests(shiftRequestsData);
        }
        setIsListLoading(false);
    };

    useEffect(() => {
        getShiftRequests();
    }, [
        selectedCompany,
        selectedSubCompany,
        selectedStartDate,
        selectedEndDate,
        selectedStatus,
        selectedCity
    ]);

    const fetchShiftRequests = async params => {
        const response = await stores.shiftRequestStore.getShiftRequests(params);
        return response?.rows || [];
    };

    const handleOnUpdateShiftRequest = async values => {
        const data = {
            requestDate: values?.shiftDate.format("YYYY-MM-DD"),
            requestStartTime: values?.shiftTime?.[0].format("HH:mm"),
            requestEndTime: values?.shiftTime?.[1].format("HH:mm"),
            personCount: Number(values?.courierCount),
            shiftNote: values?.shiftNote,
            status: values?.status
        };

        const response = await stores.shiftRequestStore.updateShiftRequestByOperation({
            id: values?.id ?? selectedShiftRequest._id,
            ...data
        });

        if (response) {
            getShiftRequests();
            setIsCreateModalOpen(false);
        }
    };

    const handleChangeShiftStatusRequest = async record => {
        const data = {
            id: record._id,
            requestDate: moment(record.date).format("YYYY-MM-DD"),
            requestStartTime: record.startTime.substring(0, record.startTime.length - 3),
            requestEndTime: record.endTime.substring(0, record.endTime.length - 3),
            personCount: Number(record.personCount),
            shiftNote: record.shiftNote,
            status: record?.newStatus
        };

        const response = await stores.shiftRequestStore.updateShiftRequestByOperation({
            ...data
        });

        if (response) {
            getShiftRequests();
            setIsCreateModalOpen(false);
        }
    };

    return {
        isListLoading,
        shiftRequests,
        selectedCompany,
        selectedSubCompany,
        setSelectedCompany,
        setSelectedSubCompany,
        selectedCity,
        setSelectedCity,
        selectedStatus,
        setSelectedStatus,
        selectedStartDate,
        setSelectedStartDate,
        selectedEndDate,
        setSelectedEndDate,
        isCreateModalOpen,
        setIsCreateModalOpen,
        selectedShiftRequest,
        handleOnUpdateShiftRequest,
        setSelectedShiftRequest,
        handleChangeShiftStatusRequest
    };
};
